import firebase from 'firebase/compat/app'

import credentials from './credentials'

// https://firebase.google.com/docs/reference/js
// https://firebase.google.com/docs/reference/js/firebase.app

export const app = firebase.initializeApp(credentials)
